import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { ContainerStationBasicInfoFragmentDoc } from '../fragments/ContainerStationBasicInfo.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetScanTunnelSessionQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type GetScanTunnelSessionQuery = { __typename?: 'Query', getScanTunnelSession: { __typename?: 'ScanTunnelSession', id: string, scan_tunnel_id: string, active_until?: string | null, is_active: boolean, containers: Array<{ __typename?: 'ContainerStationContainer', type_id: number, type_name: string, image_url?: string | null, name: string, id: string, owner_since: string, owner_till?: string | null, status: Types.ContainerLocationStatus }>, container_stations: Array<{ __typename?: 'ContainerStation', id: string, name: string, item_type: { __typename?: 'ItemType', id: number, name: string, color_hex_code?: string | null, category: Types.ItemTypeCategory, epc_asset_id: number, image_url?: string | null } }> } };


export const GetScanTunnelSessionDocument = gql`
    query GetScanTunnelSession($id: ID!) {
  getScanTunnelSession(id: $id) {
    id
    scan_tunnel_id
    active_until
    is_active
    containers {
      type_id
      type_name
      image_url
      name
      id
      owner_since
      owner_till
      status
    }
    container_stations {
      ...ContainerStationBasicInfo
    }
  }
}
    ${ContainerStationBasicInfoFragmentDoc}`;

/**
 * __useGetScanTunnelSessionQuery__
 *
 * To run a query within a React component, call `useGetScanTunnelSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScanTunnelSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScanTunnelSessionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetScanTunnelSessionQuery(baseOptions: Apollo.QueryHookOptions<GetScanTunnelSessionQuery, GetScanTunnelSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScanTunnelSessionQuery, GetScanTunnelSessionQueryVariables>(GetScanTunnelSessionDocument, options);
      }
export function useGetScanTunnelSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScanTunnelSessionQuery, GetScanTunnelSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScanTunnelSessionQuery, GetScanTunnelSessionQueryVariables>(GetScanTunnelSessionDocument, options);
        }
export type GetScanTunnelSessionQueryHookResult = ReturnType<typeof useGetScanTunnelSessionQuery>;
export type GetScanTunnelSessionLazyQueryHookResult = ReturnType<typeof useGetScanTunnelSessionLazyQuery>;
export type GetScanTunnelSessionQueryResult = Apollo.QueryResult<GetScanTunnelSessionQuery, GetScanTunnelSessionQueryVariables>;